import OmniApiClient from "./base";

export const godelApi = {
  listCredentials: () => OmniApiClient.get("/godel/credentials/"),

  createCredentials: (payload) =>
    OmniApiClient.post("/godel/credentials/", payload),

  updateCredentials: (id, payload) =>
    OmniApiClient.put(`/godel/credentials/${id}`, payload),

  deleteCredentials: (id) => OmniApiClient.delete(`/godel/credentials/${id}`),

  testConnectivity: () => OmniApiClient.post("/godel/credentials/test"),

  testStoredConnectivity: (id) =>
    OmniApiClient.post(`/godel/credentials/${id}/test`),

  scrapeCatalog: (payload = {}) =>
    OmniApiClient.post("/godel/catalog/scrape", payload),

  getProducts: (
    page = 1,
    pageSize = 50,
    search = "",
    sortBy = "updated_at",
    sortOrder = "desc",
  ) =>
    OmniApiClient.get("/godel/products", {
      params: {
        page,
        page_size: pageSize,
        search: search || undefined,
        sort_by: sortBy,
        sort_order: sortOrder,
      },
    }),

  exportProductsCsv: (search = "", sortBy = "name", sortOrder = "asc") =>
    OmniApiClient.get("/godel/products/export.csv", {
      params: {
        search: search || undefined,
        sort_by: sortBy,
        sort_order: sortOrder,
      },
      responseType: "blob",
    }),

  getCronStatus: () => OmniApiClient.get("/godel/cron/status"),

  startCron: (schedule) =>
    OmniApiClient.post("/godel/cron/start", null, {
      params: { schedule },
    }),

  stopCron: () => OmniApiClient.post("/godel/cron/stop"),
};
